// src/services/cognixToolService.js
import axios from 'axios';
import { API_CONFIG } from '../config/api';

const API_BASE_URL = API_CONFIG.BASE_URL;

const createAuthenticatedRequest = () => {
  const token = localStorage.getItem('token') || localStorage.getItem('authToken');

  if (!token) {
    console.error('❌ No authentication token found');
    throw new Error('No authentication token found. Please login again.');
  }

  return axios.create({
    baseURL: API_BASE_URL,
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json'
    }
  });
};

const handleApiError = (error, operation) => {
  console.error(`❌ ${operation} failed:`, error);

  if (error.response?.status === 401) {
    throw new Error('Authentication failed. Please login again.');
  } else if (error.response?.status === 403) {
    throw new Error('Access denied. You do not have permission for this operation.');
  } else if (error.response?.status === 404) {
    throw new Error('Resource not found.');
  } else if (error.response?.data?.detail) {
    throw new Error(error.response.data.detail);
  } else if (error.message) {
    throw new Error(error.message);
  } else {
    throw new Error(`${operation} failed. Please try again.`);
  }
};

export const cognixToolService = {
  // Create a new tool
  createTool: async (toolData) => {
    try {
      const api = createAuthenticatedRequest();
      const response = await api.post('/api/cognix-tools/create', toolData);
      console.log('✅ createTool success:', response.data);
      return response.data;
    } catch (error) {
      handleApiError(error, 'Creating Cognix Tool');
    }
  },

  // List all tools for the current user
  listTools: async () => {
    try {
      const api = createAuthenticatedRequest();
      const response = await api.get('/api/cognix-tools/list');
      console.log('✅ listTools success:', response.data);
      return response.data;
    } catch (error) {
      handleApiError(error, 'Listing Cognix Tools');
    }
  },

  // Get a single tool by UUID
  getTool: async (toolUuid) => {
    try {
      const api = createAuthenticatedRequest();
      const response = await api.get(`/api/cognix-tools/${toolUuid}`);
      console.log('✅ getTool success:', response.data);
      return response.data;
    } catch (error) {
      handleApiError(error, 'Getting Cognix Tool');
    }
  },

  // Update a tool
  updateTool: async (toolUuid, updates) => {
    try {
      const api = createAuthenticatedRequest();
      const response = await api.put(`/api/cognix-tools/${toolUuid}`, updates);
      console.log('✅ updateTool success:', response.data);
      return response.data;
    } catch (error) {
      handleApiError(error, 'Updating Cognix Tool');
    }
  },

  // Soft-delete a tool
  deleteTool: async (toolUuid) => {
    try {
      const api = createAuthenticatedRequest();
      const response = await api.delete(`/api/cognix-tools/${toolUuid}`);
      console.log('✅ deleteTool success:', response.data);
      return response.data;
    } catch (error) {
      handleApiError(error, 'Deleting Cognix Tool');
    }
  }
};

export default cognixToolService;
